'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serviceTypeTransitions = exports.default = undefined;

var _ServiceState = require('./ServiceState');

var _ServiceState2 = _interopRequireDefault(_ServiceState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceType = {
  LOCAL: 'LOCAL',
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE'
};

var localServiceLifeCycle = {
  CREATED: [_ServiceState2.default.INITIALIZING],
  INITIALIZING: [_ServiceState2.default.CREATED, _ServiceState2.default.READY],
  READY: [_ServiceState2.default.ERROR],
  ERROR: []
};

var publicServiceLifeCycle = {
  CREATED: [_ServiceState2.default.INITIALIZING],
  INITIALIZING: [_ServiceState2.default.CREATED, _ServiceState2.default.OFFLINE],
  OFFLINE: [_ServiceState2.default.CONNECTING],
  CONNECTING: [_ServiceState2.default.OFFLINE, _ServiceState2.default.READY],
  READY: [_ServiceState2.default.OFFLINE, _ServiceState2.default.ERROR],
  ERROR: []
};

var privateServiceLifeCycle = {
  CREATED: [_ServiceState2.default.INITIALIZING],
  INITIALIZING: [_ServiceState2.default.CREATED, _ServiceState2.default.OFFLINE],
  OFFLINE: [_ServiceState2.default.CONNECTING],
  CONNECTING: [_ServiceState2.default.OFFLINE, _ServiceState2.default.ONLINE],
  ONLINE: [_ServiceState2.default.OFFLINE, _ServiceState2.default.AUTHENTICATING],
  AUTHENTICATING: [_ServiceState2.default.ONLINE, _ServiceState2.default.READY],
  READY: [_ServiceState2.default.OFFLINE, _ServiceState2.default.ONLINE, _ServiceState2.default.ERROR],
  ERROR: []
};

var serviceTypeTransitions = {
  LOCAL: localServiceLifeCycle,
  PUBLIC: publicServiceLifeCycle,
  PRIVATE: privateServiceLifeCycle
};

exports.default = ServiceType;
exports.serviceTypeTransitions = serviceTypeTransitions;